import React, { useState, useEffect, useRef } from 'react';
import { HiOutlineChat, HiOutlineQuestionMarkCircle, HiPaperAirplane, HiMicrophone, HiOutlineStop } from 'react-icons/hi';
import axiosInstance from '../config/axios';
import { Link } from 'react-router-dom';
import toastService from '../services/toast';
// مكون الرسالة
const MessageBubble = ({ message, isUser }) => {
  // تعديل الكلاسات لجعل رسائل المدرب في الشمال والمستخدم في اليمين
  const bubbleClass = isUser
    ? 'bg-blue-600 text-white rounded-tl-lg rounded-tr-lg rounded-bl-lg ml-auto'
    : 'bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-white rounded-tl-lg rounded-tr-lg rounded-br-lg mr-auto';

  // تغيير محاذاة النص داخل الفقاعة
  const textAlignClass = isUser ? 'text-right' : 'text-left';

  // تحديد ما إذا كانت الرسالة صوتية
  const isAudioMessage = message.content_type === 'audio';
  
  // سجل تصحيح لمعرفة مسار الملف الصوتي
  if (isAudioMessage) {
    // Audio message details logging
  }

  return (
    <div className={`mb-3 w-full flex ${isUser ? 'justify-end' : 'justify-start'}`}>
      {/* فقاعة الرسالة فقط بدون صور */}
      <div className={`inline-block px-3 py-2 rounded-lg ${isAudioMessage ? (isUser ? 'bg-blue-200 dark:bg-blue-900/30 border border-blue-300 dark:border-blue-800 ml-auto' : 'bg-gray-200 dark:bg-gray-800/50 border border-gray-300 dark:border-gray-700 mr-auto') : bubbleClass}`} style={{maxWidth: isAudioMessage ? '280px' : 'auto'}}>
        {/* المتدرب يمين والمدرب شمال */}
        {isAudioMessage ? (
          // عرض مشغل الصوت إذا كانت رسالة صوتية
          <div className="my-1">
            <div className="text-xs mb-1 font-medium text-center">
              {message.sender_type === 'trainee' ? (isUser ? 'رسالة صوتية' : 'رسالة صوتية') : 'رسالة صوتية'}
            </div>
            <div style={{ 
              padding: '2px', 
              display: 'inline-block'
            }}>
              <audio 
                controls 
                controlsList="nodownload" 
                src={message.file_path ? `${axiosInstance.defaults.baseURL}/storage/${message.file_path}` : ''} 
                className="max-w-[250px]"
                preload="metadata"
                onContextMenu={(e) => e.preventDefault()} 
                onError={(e) => {
                  // Handle audio error gracefully
                }}
              />
            </div>
          </div>
        ) : (
          // عرض النص إذا كانت رسالة نصية
          <p className={`text-sm ${textAlignClass}`}>{message.message}</p>
        )}
        <div className={`text-xs mt-1 opacity-75 ${isUser ? 'text-right' : 'text-left'}`}>
          {(() => {
            const date = new Date(message.created_at);
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const ampm = hours >= 12 ? 'م' : 'ص';
            const hour12 = hours % 12 || 12;
            return `${hour12}:${minutes < 10 ? '0' + minutes : minutes} ${ampm}`;
          })()}
          {message.is_read && isUser && (
            <span className="mr-2">✓</span>
          )}
        </div>
      </div>
    </div>
  );
};

// مكون اختيار الدورة
const CourseSelector = ({ courses, selectedCourse, onCourseChange }) => {
  return (
    <div className="mb-4">
      <select 
        className="input-base"
        value={selectedCourse?.id || ""}
        onChange={(e) => {
          e.preventDefault(); // منع السلوك الافتراضي
          const course = courses.find(c => c.id === parseInt(e.target.value));
          onCourseChange(course);
          // منع التمرير التلقائي للصفحة
          return false;
        }}
      >
        <option value="" disabled>اختر الدورة</option>
        {courses.map(course => (
          <option key={course.id} value={course.id}>{course.name}</option>
        ))}
      </select>
    </div>
  );
};

// صفحة اسأل مدرب للمستخدمين (User Ask Instructor Page)
const UserAskInstructor = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [userHasCourses, setUserHasCourses] = useState(false);
  const [hasCoursesWithInstructorSupport, setHasCoursesWithInstructorSupport] = useState(false);
  
  // حالة الشات
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [conversationId, setConversationId] = useState(null);
  const [isRecording, setIsRecording] = useState(false);
  const [isLoadingMessages, setIsLoadingMessages] = useState(false);
  const [instructorStatus, setInstructorStatus] = useState('offline');
  const [lastMessageId, setLastMessageId] = useState(0);
  const messagesEndRef = useRef(null);
  const chatContainerRef = useRef(null);
  
  // جلب الدورات من API
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        // جلب قائمة الدورات التي يمكن للمتدرب التواصل مع مدربيها
        const response = await axiosInstance.get('/api/enrolled-courses/with-instructor-support');
        
        if (response.data && Array.isArray(response.data)) {
          setCourses(response.data);
          setUserHasCourses(response.data.length > 0);
          setHasCoursesWithInstructorSupport(response.data.length > 0);
        } else {
          setCourses([]);
          setUserHasCourses(false);
          setHasCoursesWithInstructorSupport(false);
          // Invalid courses data format
        }
      } catch (error) {
        // Error fetching courses
        // في حالة الخطأ، نضع قائمة فارغة
        setCourses([]);
        setUserHasCourses(false);
        setHasCoursesWithInstructorSupport(false);
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchCourses();
  }, []);
  
  // عند تغيير الدورة، نجلب المحادثة
  useEffect(() => {
    if (selectedCourse) {
      // نمنع صفحة البداية من التمرير قبل تحميل المحادثة
      if (window.scrollY !== 0) {
        window.scrollTo(0, 0);
      }
      fetchOrCreateConversation();
    }
  }, [selectedCourse]);
  
  // التمرير التلقائي إلى آخر رسالة
  useEffect(() => {
    // نمرر فقط عند إرسال رسالة جديدة من المتدرب
    if (messages.length > 0 && 
        !isLoadingMessages && 
        messages[messages.length-1].sender_type === 'trainee') {
      // تمرير داخل منطقة الشات فقط
      chatContainerRef.current?.scrollTo({
        top: chatContainerRef.current.scrollHeight,
        behavior: 'smooth'
      });
    }
  }, [messages, isLoadingMessages]);
  
  // التحقق من حالة المدرب
  const checkInstructorStatus = async (instructorId) => {
    try {
      const response = await axiosInstance.get('/api/chat/instructor-status', {
        params: { instructor_id: instructorId }
      });
      
      if (response.data.status === 'success') {
        setInstructorStatus(response.data.is_online ? 'online' : 'offline');
        return response.data.is_online;
      } else {
        setInstructorStatus('offline');
        return false;
      }
    } catch (error) {
      // Error checking instructor status
      setInstructorStatus('offline');
      return false;
    }
  };

  // جلب المحادثة أو إنشاء واحدة جديدة
  const fetchOrCreateConversation = async () => {
    if (!selectedCourse) return;

    setIsLoadingMessages(true);
    
    try {
      // إنشاء أو جلب محادثة موجودة
      const response = await axiosInstance.post('/api/chat/create-conversation', {
        course_id: selectedCourse.id
      });
      
      const conversationId = response.data.conversation_id;
      setConversationId(conversationId);
      
      if (response.data.messages && response.data.messages.length > 0) {
        setMessages(response.data.messages);
        setLastMessageId(response.data.messages[response.data.messages.length - 1].id);
        
        // التحقق من حالة المدرب عند دخول المحادثة فقط
        if (selectedCourse && selectedCourse.instructors && selectedCourse.instructors.length > 0) {
          // استدعاء دالة التحقق من حالة المدرب
          await checkInstructorStatus(selectedCourse.instructors[0].id);
        } else {
          setInstructorStatus('offline');
        }
      } else {
        // لا توجد رسائل سابقة
        setMessages([]);
        setLastMessageId(0);
        setInstructorStatus('offline');
      }
      
      setIsLoadingMessages(false);
    } catch (error) {
      // Error fetching conversation
      setIsLoadingMessages(false);
    }
  };
  

  
  const handleSendMessage = async (e) => {
    if (e) e.preventDefault();
    
    if (!newMessage.trim() || !conversationId || !selectedCourse) return;
    
    try {
      // إرسال الرسالة
      const response = await axiosInstance.post('/api/chat/messages', {
        conversation_id: conversationId,
        course_id: selectedCourse.id,
        message: newMessage,
        content_type: 'text'
      });
      
      // إضافة الرسالة للقائمة
      setMessages(prev => [...prev, response.data]);
      setLastMessageId(response.data.id);
      setNewMessage('');
      
    } catch (error) {
      // Error sending message
    }
  };
  
  // متغيرات للتسجيل الصوتي
  const [audioRecorder, setAudioRecorder] = useState(null);
  const [audioBlob, setAudioBlob] = useState(null);
  
  // دالة تسجيل الصوت
  const handleRecordAudio = async () => {
    if (isRecording) {
      // إيقاف التسجيل
      if (audioRecorder) {
        audioRecorder.stop();
      }
      setIsRecording(false);
      // إغلاق التوست فوراً عند إيقاف التسجيل
      toastService.dismiss();
    } else {
      try {
        // طلب إذن الميكروفون
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        const recorder = new MediaRecorder(stream);
        setAudioRecorder(recorder);
        
        // تخزين البيانات المسجلة
        const audioChunks = [];
        recorder.ondataavailable = (e) => {
          if (e.data.size > 0) {
            audioChunks.push(e.data);
          }
        };
        
        // عند انتهاء التسجيل
        recorder.onstop = () => {
          // إنشاء ملف صوتي من البيانات المسجلة
          const audioBlob = new Blob(audioChunks, { type: 'audio/mp3' });
          setAudioBlob(audioBlob);
          
          // إرسال الرسالة الصوتية
          sendAudioMessage(audioBlob);
          
          // إغلاق المسارات الصوتية
          stream.getTracks().forEach(track => track.stop());
        };
        
        // بدء التسجيل
        recorder.start();
        setIsRecording(true);
        // إظهار إشعار جاري التسجيل
        toastService.info('جاري التسجيل...');
      } catch (error) {
        // Error accessing microphone
        alert('لا يمكن الوصول إلى الميكروفون. يرجى التحقق من إعدادات المتصفح.');
      }
    }
  };
  
  // دالة إرسال الرسالة الصوتية
  const sendAudioMessage = async (blob) => {
    if (!conversationId || !selectedCourse) return;
    
    try {
      // Sending audio message
      // إنشاء FormData لإرسال الملف
      const formData = new FormData();
      formData.append('conversation_id', conversationId);
      formData.append('course_id', selectedCourse.id);
      formData.append('content_type', 'audio');
      formData.append('message', ' '); // إضافة حقل message فارغ
      formData.append('sender_type', 'trainee'); // إضافة نوع المرسل (متدرب)
      formData.append('file', blob, `voice_message_${Date.now()}.mp3`); // استخدام file بدلاً من audio_file
      
      // للتحقق من محتوى FormData
      for (let pair of formData.entries()) {
        // FormData entry logging
      }
      
      // إرسال الطلب
      const response = await axiosInstance.post('/api/chat/send-message', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      // إضافة الرسالة إلى قائمة الرسائل
      if (response.data) {
        setMessages(prev => [...prev, response.data]);
        scrollToBottom();
      }
    } catch (error) {
      // Error sending audio message
      alert('حدث خطأ أثناء إرسال الرسالة الصوتية');
    }
  };
  
  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTo({
        top: chatContainerRef.current.scrollHeight,
        behavior: 'smooth'
      });
    }
  };
  
  // عرض شاشة التحميل
  if (isLoading) {
    return (
      <div className="min-h-screen flex flex-col justify-between">
        <div className="flex-grow flex items-center justify-center">
          <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
        </div>
      </div>
    );
  }
  
  // إذا لم تكن هناك دورات تدعم خاصية اسأل مدرب (سواء لأن المستخدم غير مشترك بأي دورات أو لأن الدورات لا تدعم الخاصية)
  if (!userHasCourses || !hasCoursesWithInstructorSupport) {
    return (
      <div className="min-h-screen flex flex-col justify-between">
        <div className="flex-grow flex items-center justify-center">
          <div className="max-w-lg w-full bg-white dark:bg-gray-800 shadow-md rounded-lg p-8 text-center mx-4">
            <HiOutlineQuestionMarkCircle className="mx-auto h-14 w-14 text-blue-600 mb-4" />
            <div className="border-2 border-blue-100 dark:border-blue-700 bg-blue-50 dark:bg-gray-800 p-4 rounded-lg">
              <h2 className="text-xl font-bold text-blue-600 dark:text-blue-300 mb-5">لا توجد دورات تدعم "اسأل مدرب" في حسابك</h2>
              
              <p className="text-base text-gray-700 dark:text-gray-100 mb-3 font-semibold">- أنت غير مشترك في أي دورات</p>
              <p className="text-base text-gray-700 dark:text-gray-100 font-semibold">- الدورات المشترك بها لا تدعم هذه الخاصية</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  // المستخدم لديه دورات تدعم خاصية اسأل مدرب
  return (
    <div className="min-h-screen flex flex-col justify-between">
      <div className="flex justify-center items-start">
      <div className="container mt-16 mb-8 mx-auto px-4">
      
      <div className="max-w-4xl w-full mx-auto bg-white dark:bg-gray-800 shadow-md rounded-lg overflow-hidden border border-gray-200 dark:border-gray-700">
        {/* رأس البطاقة */}
        <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center">
          <div className="flex items-center gap-2">
            <h2 className="text-lg font-medium text-gray-900 dark:text-white">اسأل مدرب</h2>
            {selectedCourse && (
              <>
                <span className="text-sm text-gray-500 dark:text-gray-400">|</span>
                <p className="text-sm text-gray-500 dark:text-gray-400">{selectedCourse.name}</p>
              </>
            )}
          </div>
          <HiOutlineChat className="h-6 w-6 text-blue-600 hover:text-blue-700 dark:text-blue-500 dark:hover:text-blue-400 transition-colors duration-200" />
        </div>
        
        {/* تم إزالة معلومات المدرب من الهيدر */}
        
        {/* اختيار الدورة */}
          <div className="p-4 border-b border-gray-200 dark:border-gray-700">
            <CourseSelector 
              courses={courses} 
              selectedCourse={selectedCourse} 
              onCourseChange={setSelectedCourse} 
            />
          </div>
          
          {/* اسم المدرب في المنتصف */}
          {instructorStatus === 'online' && selectedCourse && selectedCourse.instructors && selectedCourse.instructors.length > 0 && (
            <div className="text-center py-2 border-b border-gray-200 dark:border-gray-700">
              <div className="text-yellow-600 font-bold">
                {selectedCourse.instructors[0].name || 'المدرب'}
              </div>
            </div>
          )}
          
          {/* محتوى الشات */}
          {selectedCourse ? (
          <div className="flex flex-col h-[calc(100vh-350px)] md:h-[calc(100vh-350px)] sm:h-[calc(100vh-400px)] xs:h-[calc(100vh-450px)]">
              {/* فقاعة حالة المدرب في الأعلى بخلفية شفافة */}
              <div className="relative w-full h-0">
                <div className="absolute left-1/2 top-4 transform -translate-x-1/2">
                  <div className="px-4 py-2 rounded-full text-xs shadow-sm bg-opacity-100 bg-gray-100 dark:bg-opacity-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300">
                    {instructorStatus === 'online' ? (
                      <span className="flex items-center">
                        <span className="h-2 w-2 rounded-full bg-green-500 ml-2"></span>
                        <span className="mx-2">متصل الآن</span>
                      </span>
                    ) : (
                      <span className="flex items-center">
                        <span className="h-2 w-2 rounded-full bg-gray-500"></span>
                        <span className="mx-2">غير متصل حالياً</span>
                      </span>
                    )}
                  </div>
                </div>
              </div>
              
              {/* منطقة الرسائل */}
              <div 
                className="flex-1 p-4 overflow-y-auto scrollbar-none" 
                ref={chatContainerRef}
                style={{ 
                  scrollBehavior: 'smooth',
                  msOverflowStyle: 'none',
                  scrollbarWidth: 'none'
                }}
              >
                {isLoadingMessages ? (
                  <div className="flex justify-center items-center h-full">
                    <div className="w-10 h-10 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
                  </div>
                ) : messages.length === 0 ? (
                  <div className="flex flex-col items-center justify-center h-full text-gray-500 dark:text-gray-400">
                    <HiOutlineChat className="h-12 w-12 mb-3" />
                    <p>لا توجد رسائل بعد. ابدأ محادثة جديدة مع المدرب.</p>
                  </div>
                ) : (
                  <div className="flex flex-col">
                    
                    {messages.map(message => (
                      <div
                        key={message.id}
                        className="w-full"
                      >
                        <MessageBubble 
                          message={message} 
                          isUser={message.sender_type === 'trainee'}
                          sender={selectedCourse?.instructors?.[0] || {
                            name: message.sender_role === 'admin' ? 'المدير' : message.sender_role === 'supervisor' ? 'المشرف' : 'المدرب',
                            avatar: '/images/default-avatar.png'
                          }}
                        />
                      </div>
                    ))}
                    <div ref={messagesEndRef} />
                  </div>
                )}
              </div>
              
              {/* منطقة إدخال الرسالة */}
              <div className="p-4 border-t border-gray-200 dark:border-gray-700">
                <form onSubmit={handleSendMessage} className="w-full">
                  <div className="flex items-center">
                    <button
                      type="button"
                      onClick={handleRecordAudio}
                      className={`p-2 rounded-full ml-2 ${isRecording 
                        ? 'bg-red-500 text-white animate-pulse' 
                        : 'bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'}`}
                    >
                      {isRecording ? (
                        <HiOutlineStop className="h-5 w-5" />
                      ) : (
                        <HiMicrophone className="h-5 w-5" />
                      )}
                    </button>
                    <input
                      type="text"
                      className="input-base flex-1"
                      placeholder="اكتب رسالتك هنا..."
                      value={newMessage}
                      onChange={(e) => setNewMessage(e.target.value)}
                    />
                    <button 
                      type="submit"
                      disabled={!newMessage.trim()}
                      className={`p-2 rounded-full mr-4 ${newMessage.trim() ? 'bg-green-500 text-white hover:bg-green-600' : 'text-gray-400 dark:text-gray-600'}`}
                    >
                      <HiPaperAirplane className="h-5 w-5 transform rotate-90" />
                    </button>
                  </div>
                  {/* تم إزالة شريط جاري التسجيل والاكتفاء بأيقونة التسجيل النابضة */}
                </form>
              </div>
            </div>
          ) : (
            <div className="p-8 text-center text-gray-600 dark:text-gray-300">
              <p>الرجاء اختيار دورة للبدء في المحادثة مع المدرب</p>
            </div>
          )}
        </div>
      </div>
      </div>
      </div>
  );
};

export default UserAskInstructor;
